const channelObjects = Bb.Radio.channel( 'objects' );
const UnitUserAccess = {
	
	canInstall: function ( unit, user ) {
		return user.isInstallerAutomotive() && unit.isAutomotive() ||
			   user.isInstallerHome() && unit.isHome();
	},
	
	
	/**
	 * Checks if the current user is the installer of the current unit.
	 * @return {bool} True if the installer id matches, false if not.
	 */
	isCurrentInstaller: function ( unit, user ) {
		let customerIds = user.getCustomers().pluck( 'id' );
		return _.contains( customerIds, unit.get( 'transientInstallerId' ) );
	},
	
	hasUnitControlAccess: function ( unit, user ) {
		if (unit.hasSubscription()) {
			return this.isOwner(unit, user) || user.isTechSupport() || user.get('transientUnits').includes(unit.get('id'))
		}else {
			return unit.isHome && ( user.isTechSupport() || this.isCurrentInstaller(unit, user)) && unit.get( 'transientIsConfiguring' );
		}
	},
	
	isOwner: function ( unit, user ) {
		
		// technical support owns all units
		if ( user.isTechSupport() ) {
			return true;
		}
		
		let subscription = channelObjects.request( 'subscriptions' ).get( unit.get( 'transientSubscription' ) );
		
		// a unit without a subscription has no owner
		if ( !subscription ) {
			return false;
		} else {
			
			// get owner id and user customer id's
			let owner = subscription.get( 'owner' ),
				ids   = user.getCustomers().pluck( 'id' );
			
			return _.contains( ids, owner );
			
		}
	},
};

export default UnitUserAccess;
